import makeApiRequest from './makeApiCall';

export const getCashFlow = async (data) => {
  return await makeApiRequest(`/ledger/cashflow-cib`, 'POST', null, data);
};

export const getCashFlowExport = async (params) => {
  return await makeApiRequest(
    `/ledger/cashflow-cib/export`,
    'POST',
    null,
    params,
  );
};
